<section class="link-options-wrapper">
    <app-confirm-popup [triggerModal]="showModal" *ngIf="showModal" [title]="'Delete'"
        [message]="
        activeTab == 'Linked AR/EDP' ? 'Are you sure you want to delete the selected EDP/AR association(s)?': 'Are you sure you want to delete the selected Program association(s)?'" [confirmText]="'Delete'" [cancelText]="'Cancel'"
        (confirm)="onDeleteConfirm()" (cancel)="onDeleteCancel()"></app-confirm-popup>
    <div class="link-options-tab">
        <ul class="nav">
            @for(item of linkedStatus;track item.id) {
            <li class="nav-item">
                <a (click)="handleTab(item)" [ngClass]="item.clicked ? 'active-tab' : ''"
                    class="nav-link active">{{item.name}}</a>
            </li>
            }
        </ul>
    </div>

    <div class="link-options-block mt-3 row mb-2">
        @if(activeTab == 'Linked AR/EDP'){
        <ng-container>
            <div class="col-md-12 search-input-wrapper mb-4">
                <label class="form-label">EDP/AR # <span class="text-danger">*</span></label>
                <div class="col-md-12 d-flex flex-column mb-2 custom-select-v2">
                    <nz-select nzMode="multiple" [(ngModel)]="edpArValue" [nzDropdownRender]="dropDownRender"
                        #multiSelectRef="nzSelect" nzPlaceHolder="Enter EDP/AR #" [nzShowSearch]="true"
                        [nzAllowClear]="true" (nzOnSearch)="searchAdpErNo($event,seqId)">
                        @for (option of edpArNoList; track option) {
                        <nz-option [nzLabel]="option" [nzValue]="option"></nz-option>
                        }
                    </nz-select>
                    <span class="text-danger" *ngIf="edpArValue?.length == 0 && validateValues">
                        Atleast one EDP/AR # value is required.
                    </span>
                    <ng-template #dropDownRender>
                        <div class="d-flex justify-content-end p-2">
                            <button nz-button nzType="primary" class="ok-btn" (click)="closeSelect(multiSelectRef)">
                                Ok
                            </button>
                        </div>
                    </ng-template>
                </div>
                <div class="col-md-8 d-flex mb-2">
                    <button nz-button nzType="primary" [disabled]="DefaultExists" (click)="pushDefault()">DEFAULT
                        CONTENT</button>
                </div>
            </div>
        </ng-container>
        }
        @else {
        <div class="col-md-6 mb-2 d-flex flex-column">
            <label class="form-label">Program Name</label>
            <nz-select [(ngModel)]="programValue" (ngModelChange)="getWorkProgramList()" nzAllowClear="true"
                nzShowSearch="true" nzPlaceHolder="Select Program" nzSize="default" style="height: 35px !important;">
                @for(prgrm of programList;track prgrm.cprogramcode){
                <nz-option [nzValue]="prgrm.cprogramcode"
                    [nzLabel]="prgrm.cprogramcode + ' - ' + prgrm.xprogramname"></nz-option>
                }

            </nz-select>
            <span class="text-danger" *ngIf="!programValue && validateValues">
                Program value is required.
            </span>
        </div>
        <div class="col-md-6 mb-2 d-flex flex-column custom-select-v2">
            <label class="form-label"> Workgroup List</label>
            <nz-select nzMode="multiple" #multiSelectWorkRef="nzSelect" [(ngModel)]="workProgramValue"
                nzAllowClear="true" nzPlaceHolder="Select Workgroup" nzSize="default"
                (ngModelChange)="onWorkgroupChange($event)"
                [nzDropdownRender]="dropDownRender">
                @for(prgrm of workProgramList;track prgrm.cWorkgroupid){
                <nz-option [nzDisabled]="prgrm.cWorkgroupid === '0' ? isOthersSelected : isZeroSelected"  [nzValue]="prgrm.cWorkgroupid" [nzLabel]="prgrm.cWorkgroupname"></nz-option>
                }
            </nz-select>
            <span class="text-danger" *ngIf="workProgramValue.length == 0 && validateValues">
                Workgroup value is required.
            </span>
            <ng-template #dropDownRender>

                <div class="d-flex justify-content-end p-2">
                    <button nz-button nzType="primary" class="ok-btn" (click)="closeSelect(multiSelectWorkRef)">
                        Ok
                    </button>
                </div>

            </ng-template>
        </div>
        }
        <div class="col-md-6 d-flex flex-column mb-4 ">
            <label class="form-label">Start Date & Time</label>
            <div class="d-flex px-0 ">
                <nz-date-picker class="mr-5" [nzDisabledDate]="disablePastDates"
                    nzPlaceHolder="Select Start Date & Time" style="height: 32px;width: 90%;" [(ngModel)]="startDate"
                    (ngModelChange)="openEndPicker()" [nzShowTime]="true"></nz-date-picker>
            </div>
        </div>
        <div class="col-md-6 d-flex flex-column mb-4 ">
            <label class="form-label">End Date & Time</label>
            <div class="d-flex px-0">
                <nz-date-picker class="ml-5" [nzDisabledDate]="disabledDate" [nzDisabled]="!startDate" #endDatePicker
                    nzPlaceHolder="Select End Date & Time" style="height: 32px;width: 90%;" [(ngModel)]="endDate"
                    [nzShowTime]="true"></nz-date-picker>
            </div>
        </div>
        <div class="col-md-12 d-flex flex-row mb-2 justify-content-end">
            <button (click)="resetForm()" nz-button nzType="default">Reset</button>
            &nbsp;
            <button nz-button nzType="primary"
                (click)=" activeTab == 'Linked AR/EDP' ? updateAssociation() : updatePrgrmAssociation()"
                class="d-flex align-items-center" [disabled]="!startDate || !endDate" [nzSize]="'default'"><span nz-icon nzType="plus"></span>Add</button>
        </div>
    </div>
    <div class="associate-wrapper px-3">
        <div class="link-options-list p-2">
            <div class="link-option-header px-4 d-flex justify-content-between align-items-center">
                <label>Association List</label>
                <button nz-button nzType="primary" [disabled]="selectedIds.size == 0"
                    (click)="deAssociate()">DeAssociate</button>
            </div>
            @if(activeTab == 'Linked AR/EDP') {
            <div class="col-md-6 px-4 mt-2">
                <nz-input-group class="px-2 mr-2 search-input-group" style="width: 80%;height: 35px;" nzSize="default"
                    [nzSuffix]="suffixIconSearch">
                    <input type="text" class="py-1" nz-input placeholder="Search For EDP/AR #"
                        (keydown.enter)="searchValue(SearchText.value,'cedpNo')" [(ngModel)]="searchText" nzAllowClear
                        #SearchText />
                    <span class="close-icon" (click)="SearchText.value = '';searchValue('','cedpNo')" class="px-1"
                        nz-icon nzType="close-circle"></span>

                </nz-input-group>
                <ng-template #suffixIconSearch>
                    <span class="search-icon" (click)="searchValue(SearchText.value,'cedpNo')" nz-icon
                        nzType="search"></span>
                </ng-template>
            </div>
            <ng-container>
                <app-data-grid [columns]="edpColumns" [dataSet]="edp_ar_list" [gridStyle]="'white'"
                    (deleteRow)="deleteRow($event)" (updateRow)="updateRow($event)"
                    (selectedRows)="selectedRows($event)"></app-data-grid>
            </ng-container>
            } @else {
            <div class="col-md-8 px-4 mt-2">
                <nz-input-group class="px-2 mr-2 search-input-group" style="width: 80%;height: 35px;" nzSize="default"
                    [nzSuffix]="suffixIconSearch">
                    <input type="text" class="py-1" nz-input placeholder="Search For Program Code or WorkGroup Name"
                        (keydown.enter)="searchValue(SearchText.value,['programCode','workGroupName'])" [(ngModel)]="searchText"
                        nzAllowClear #SearchText />
                    <span class="close-icon" (click)="SearchText.value = '';searchValue('','programCode')" class="px-1"
                        nz-icon nzType="close-circle"></span>

                </nz-input-group>
                <ng-template #suffixIconSearch>
                    <span class="search-icon" (click)="searchValue(SearchText.value,'programCode')" nz-icon
                        nzType="search"></span>
                </ng-template>
            </div>
            <ng-container>
                <app-data-grid [columns]="program_fields" [dataSet]="program_list" [gridStyle]="'white'"
                    (deleteRow)="deleteProgramList($event)" (updateRow)="updateRow($event)"
                    (selectedRows)="selectedRows($event)"></app-data-grid>
            </ng-container>
            }
        </div>
    </div>
</section>